export class CustomFormatter {
    cache = {};
    formatInput(message, values) {
        return JSON.stringify([message, values]);
    }
    interpolate(message, values) {
        if (!values) {
            return [message];
        }
        const cacheKey = this.formatInput(message, values);
        const cachedValue = this.cache[cacheKey];
        if (cachedValue) {
            return [cachedValue];
        }
        const keys = Object.keys(values);
        let final = message;
        keys.forEach((key) => {
            final = final.replace(new RegExp(`\\{\\s*${key.trim()}\\s*\\}`), values[key]);
        });
        this.cache[cacheKey] = final;
        return [final];
    }
}
